/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
'use strict';

/**
 * Filter used to filter an object that has properties pointing to objects.
 */
angular
  .module('filters.objectFilterBy', [])
  /**
   * Filter used for filtering objects by a property. If no filterVal is provided no filtering will be done.
   *
   * @param {Object} input - An object with properties that are objects.
   * @param {String} filterKey - The property to filter on.
   * @param {String} filterVal - The value to filter on
   * @returns {Array[Object]} - A filtered array of the objects.
   */
  .filter('objectFilterBy', function () {
    return function (input, filterKey, filterVal) {
      var filteredInput = {};
      angular.forEach(input, function (object, key) {
        if (
          !filterVal ||
          (object[filterKey] && object[filterKey].toLowerCase().indexOf(filterVal.toLowerCase()) >= 0)
        ) {
          filteredInput[key] = object;
        }
      });
      return filteredInput;
    };
  });
